"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CollapseWrapper;
var _reactCollapse = require("react-collapse");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CollapseContainer = _styledComponents.default.div`
  .ReactCollapse--collapse {
    overflow: ${props => props.showOverflow ? 'visible !important' : 'hidden'};
    height: ${props => props.showOverflow ? 'auto !important' : 'auto'};
    transition: ${({
  transitionMS
}) => transitionMS || 500}ms;
  }
`;
function CollapseWrapper(props) {
  const [wasOpenAtEndOfLastAnimation, setWasOpenAtEndOfLastAnimation] = (0, _react.useState)(props.isOpened);
  return /*#__PURE__*/_react.default.createElement(CollapseContainer, {
    transitionMS: props.transitionMS,
    showOverflow: props.isOpened && wasOpenAtEndOfLastAnimation === props.isOpened
  }, /*#__PURE__*/_react.default.createElement(_reactCollapse.Collapse, {
    children: props.children,
    isOpened: !!props.isOpened,
    onRest: () => setWasOpenAtEndOfLastAnimation(props.isOpened)
  }));
}